import { Reveal } from '@/components/Reveal';
import { HOME } from '@/constants/testIds';

const STUDIO_CONTEXT =
    'https://static.prod-images.emergentagent.com/jobs/026e8d45-2a45-421d-be3c-026a565f857e/images/42697d9f4427a3144ed0dde05bf657fd351836e363f40ff5a9135979ecd8294e.jpeg';

const STEPS = [
    {
        n: '01',
        title: 'Say the wake phrase',
        body: '“Engineer” or “Engine.” brings ENGINE to attention — even while the session is rolling.',
    },
    {
        n: '02',
        title: 'Speak your command',
        body: 'Adjust the session by voice and keep both hands on the music. ENGINE does the rest.',
    },
    {
        n: '03',
        title: 'Stay in the session',
        body: 'No alt-tabbing, no menu diving. Just you, the mix, and your focus on the music.',
    },
];

export const HowItWorks = () => (
    <section id="how-it-works" data-testid={HOME.howItWorks} className="relative py-24 md:py-32">
        <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-14 px-6 md:grid-cols-2 md:gap-20">
            <div>
                <Reveal>
                    <p className="font-mono text-xs uppercase tracking-[0.25em] text-aqua">How it works</p>
                    <h2 className="mt-4 text-3xl font-light leading-tight tracking-tight sm:text-4xl lg:text-5xl">
                        Three beats to hands-free.
                    </h2>
                </Reveal>

                <div className="mt-12">
                    {STEPS.map((step, i) => (
                        <Reveal key={step.n} delay={0.08 * i}>
                            <div className="flex gap-6 border-t border-white/10 py-8">
                                <span className="font-mono text-sm text-aqua">{step.n}</span>
                                <div>
                                    <h3 className="text-lg font-normal tracking-tight text-white">{step.title}</h3>
                                    <p className="mt-2 max-w-md text-sm leading-relaxed text-zinc-400">{step.body}</p>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>

            <Reveal delay={0.15}>
                <div className="group relative overflow-hidden rounded-3xl border border-white/10">
                    <img
                        src={STUDIO_CONTEXT}
                        alt="A quiet studio session after dark"
                        className="aspect-[4/3] w-full object-cover opacity-85 transition-transform duration-700 group-hover:scale-[1.03]"
                    />
                    <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-t from-ink/90 via-transparent to-transparent" />
                    <p className="absolute bottom-6 left-6 font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-300">
                        The session, unbroken
                    </p>
                </div>
            </Reveal>
        </div>
    </section>
);
